import React from "react";
import { usePatientMood } from "../../hooks/usePatientMood";
import { MoodTrackingCard } from "./MoodTrackingCard";
import { MoodDistributionCard } from "./MoodDistributionCard";

interface AppTabProps {
  patientId: number | undefined;
  token: string;
}

/**
 * App tab - displays patient-generated data collected from the mobile app.
 * Uses a modular, card-based layout so additional metrics (e.g. Sleep) can be
 * added in the future. Currently renders the Daily Mood Check-In cards.
 */
export const AppTab: React.FC<AppTabProps> = ({ patientId, token }) => {
  const { entries, isLoading, isError, refetch } = usePatientMood(patientId, token);

  if (isLoading) {
    return <p className="text-xs text-gray-500 italic p-4">טוען נתוני אפליקציה...</p>;
  }

  if (isError) {
    return (
      <div className="p-4 text-center">
        <p className="text-xs text-red-600 mb-2">שגיאה בטעינת נתוני האפליקציה</p>
        <button
          onClick={() => refetch()}
          className="px-3 py-1 text-xs bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
        >
          נסה שוב
        </button>
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto p-3 space-y-3">
      <MoodTrackingCard entries={entries} />
      <MoodDistributionCard entries={entries} />
      {/* Future cards (e.g. Sleep) can be appended here. */}
    </div>
  );
};
